import { isStorageAvailable } from '../../configs/constants/index.js';

function setStorage(key, value, isLocalStorage) {
  if (isLocalStorage === void 0) {
    isLocalStorage = true;
  }
  if (!isStorageAvailable) {
    return;
  }
  try {
    var storage = isLocalStorage ? window.localStorage : window.sessionStorage;
    storage.setItem(key, value);
  } catch (_a) {}
}
function getStorage(key, isLocalStorage) {
  if (isLocalStorage === void 0) {
    isLocalStorage = true;
  }
  if (!isStorageAvailable) {
    return null;
  }
  try {
    var storage = isLocalStorage ? window.localStorage : window.sessionStorage;
    return storage.getItem(key);
  } catch (_a) {
    return null;
  }
}
function removeStorage(key, isLocalStorage) {
  if (isLocalStorage === void 0) {
    isLocalStorage = true;
  }
  if (!isStorageAvailable) {
    return;
  }
  try {
    var storage = isLocalStorage ? window.localStorage : window.sessionStorage;
    storage.removeItem(key);
  } catch (_a) {}
}
function setObjectToLocalStorage(key, value) {
  if (!isStorageAvailable) {
    return;
  }
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch (_a) {}
}
function getObjectFromLocalStorage(key) {
  if (!isStorageAvailable) {
    return null;
  }
  try {
    var obj = window.localStorage.getItem(key);
    return obj && JSON.parse(obj);
  } catch (_a) {
    return null;
  }
}

export { getObjectFromLocalStorage, getStorage, removeStorage, setObjectToLocalStorage, setStorage };
//# sourceMappingURL=index.js.map
